import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { PrivateRoute } from './components/common';
import AppLayout from './components/layout/AppLayout';
import { AuthProvider } from './contexts/AuthContext';
import Auditoria from './pages/Auditoria';
import Controles from './pages/Controles';
import ArquivoDetalhe from './pages/ArquivoDetalhe';
import ArquivoNovo from './pages/ArquivoNovo';
import Agenda from './pages/Agenda';
import AuditoriaGlosa from './pages/AuditoriaGlosa';
import Glosas from './pages/Glosas';
import Guias from './pages/Guias';
import LoteProgresso from './pages/LoteProgresso';
import Arquivos from './pages/Arquivos';
import Dashboard from './pages/Dashboard';
import Divergencias from './pages/Divergencias';
import Documentacao from './pages/Documentacao';
import Login from './pages/Login';
import Modelos from './pages/Modelos';
import ModeloNovo from './pages/ModeloNovo';
import Pendencias from './pages/Pendencias';
import Protocolos from './pages/Protocolos';
import Saldo from './pages/Saldo';
import Usuarios from './pages/Usuarios';

function Privado({ children, somenteAdmin = false, somenteGestor = false }) {
  return (
    <PrivateRoute somenteAdmin={somenteAdmin} somenteGestor={somenteGestor}>
      <AppLayout>{children}</AppLayout>
    </PrivateRoute>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route path="/dashboard" element={<Privado><Dashboard /></Privado>} />
          <Route path="/protocolos" element={<Privado><Protocolos /></Privado>} />
          <Route path="/guias" element={<Privado><Guias /></Privado>} />
          <Route path="/arquivos" element={<Privado><Arquivos /></Privado>} />
          <Route path="/arquivos/novo" element={<Privado><ArquivoNovo /></Privado>} />
          <Route path="/lotes/:id" element={<Privado><LoteProgresso /></Privado>} />
          <Route path="/agenda" element={<Privado><Agenda /></Privado>} />
          <Route path="/glosas" element={<Privado><Glosas /></Privado>} />
          <Route
            path="/glosas/auditoria"
            element={<Privado><AuditoriaGlosa /></Privado>}
          />
          <Route path="/arquivos/:id" element={<Privado><ArquivoDetalhe /></Privado>} />
          <Route path="/pendencias" element={<Privado><Pendencias /></Privado>} />
          <Route path="/divergencias" element={<Privado><Divergencias /></Privado>} />
          <Route path="/saldo" element={<Privado><Saldo /></Privado>} />
          <Route path="/documentacao" element={<Privado><Documentacao /></Privado>} />

          {/* Gestão de usuários: gestor e admin */}
          <Route path="/usuarios" element={<Privado somenteGestor><Usuarios /></Privado>} />

          {/* Aprovação de modelo e auditoria são prerrogativas do ADMIN */}
          <Route path="/modelos" element={<Privado><Modelos /></Privado>} />
          <Route path="/modelos/novo" element={<Privado><ModeloNovo /></Privado>} />
          <Route path="/auditoria" element={<Privado somenteGestor><Auditoria /></Privado>} />
          <Route path="/controles" element={<Privado somenteAdmin><Controles /></Privado>} />

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
